import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import SwiperCarsouel from "../componants/swipercarsouel/SwiperCarsouel";
import * as urls from "../utils/URLConst";
import makeRequest from "../utils/makeRequest";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toastNotify from "../utils/ToastNotify";
import { Button, Card, Col, Row } from "react-bootstrap";
import SelectField from "../componants/textField/SelectField";
import { BiHomeAlt, BiLeftArrowAlt, BiSolidStar } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { handleLoader } from "../redux/reducers/layout";

const Review = () => {
  const navigate = useNavigate();
  const [departmentProduct, setDepartmentProduct] = useState([]);

  const dispatch = useDispatch();

  const getDepartmentProduct = async () => {
    try {
      dispatch(handleLoader(true));
      const data = {
        CAT_CD: "",
        FLAG: "Y",
      };
      const config = {};
      await makeRequest(
        "POST",
        urls.getDashboardProductList,
        data,
        config
      ).then((result) => {
        if (result?.STATUS === "0") {
          const response = result.RESPONSE;
          setDepartmentProduct(response);
        } else if (result.STATUS !== "0") {
          setDepartmentProduct([]);
        }
      });
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  };

  useEffect(() => {
    getDepartmentProduct();
  }, []);

  async function generateReviewTicket(val) {
    try {
      dispatch(handleLoader(true));

      const payload = {
        DEPARTMENT_CD: "1",
        PRODUCT_CD: val.productValue,
        SUBJECT: "Review Feedback " + val.rating + " Star Rating",
        DESCRIPTION: val.discription,
        FILE_B64: "",
        FILE_SIZE: "",
        PRIORITY: "N",
        CLASSIFICATION: "O",
      };

      const config = {};
      await makeRequest("POST", urls.setTicket, payload, config).then(
        (result) => {
          if (result.STATUS === "0") {
            toastNotify(result.MESSAGE, "success");
            navigate("/support");
          } else {
            toastNotify(result.MESSAGE, "error");
          }
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(handleLoader(false));
    }
  }


  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="container-top d-flex align-items-center">
          <div className="pb-2">
            <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
            <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
              Dashboard /
            </NavLink>
            <span className="navigation-header-text ps-1"> Review</span>
          </div>
          <Button
            type="button"
            variant="warning"
            className="btn-sm ms-auto"
            onClick={() => navigate("/dashboard")}
          >
            <BiLeftArrowAlt className="text-lg me-1" />
            Back
          </Button>
        </div>

        <Row className="mt-3">
          <Col md={8}>
            <Card>
              <Card.Body>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    productValue: "",
                    productLabel: "",
                    rating: "",
                    discription: "",
                  }}
                  validationSchema={Yup.object().shape({
                    productValue: Yup.string().required("Product is requied field."),
                    rating: Yup.string().required("Rating is requied field.")
                  })}
                  onSubmit={(values) =>
                    generateReviewTicket(values)
                  }
                >
                  {({ errors, touched, values, setFieldValue, handleBlur }) => (
                    <Form>
                      <Row>
                        <Col md={6}>
                          <SelectField
                            name="product"
                            tabIndex={2}
                            options={[
                              { value: "", label: "Select Product" },
                              ...departmentProduct.map((items) => ({
                                value: items.ITEM_CD, label: items.ITEM_NM
                              }))]}
                            required
                            placeholder="Product"
                            value={values.productValue !== "" && {
                              value: values.productValue,
                              label: values.productLabel
                            }}
                            onChange={(e) => {
                              setFieldValue("productValue", e?.value);
                              setFieldValue("productLabel", e?.label);
                            }}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage name="productValue" className='error-msg' component="div" />
                        </Col>
                        <Col md={6} className="mt-md-0 mt-3">
                          <label htmlFor="" className="required text-xs text-slate-500">
                            Rating
                          </label>
                          <div className="star-rating-section mt-md-0">
                            {[1, 2, 3, 4, 5].map((i) => (
                              <div
                                key={i}
                                className={`star ${values.rating >= i ? "active" : ""} `}
                                onClick={() => setFieldValue('rating', i)}
                              >
                                <BiSolidStar style={{ color: "#ccc !important", fontSize: 25 }} />
                              </div>
                            ))}
                          </div>
                          <ErrorMessage name="rating" className='error-msg' component="div" />
                        </Col>
                        <Col md={12} className="mt-3">
                          <label
                            htmlFor="discription"
                            className="form-label fs-6 fw-normal"
                          >
                            Message
                          </label>
                          <Field
                            as="textarea"
                            className={
                              "form-control" +
                              (errors.discription && touched.discription
                                ? " is-invalid"
                                : "")
                            }
                            id="discription"
                            name="discription"
                            maxLength="150"
                            rows="3"
                            placeholder="Please write your review here . . ."
                            style={{ height: "150px" }}
                          />
                          <ErrorMessage
                            name="discription"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </Row>
                      <div className="row">
                        <div className="mb-3">

                        </div>
                      </div>
                      <div className="mt-3 mb-2">
                        <Button
                          type="submit"
                          variant="primary"
                          className="btn-sm me-2"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="m-md-0 mt-3">
            <Card
              className="card"
              style={{
                padding: "20px 0px 20px 0px",
                height: "380px",
              }}
            >
              <Card.Body
                className="py-0"
                style={{
                  overflowY: "scroll",
                }}
              >
                <SwiperCarsouel />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Review;
